/**
 * EditingConfig — registry entry (Component only; completeness is registered
 * separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { EditingConfig } from './EditingConfig.component'

export const editingConfigModule: PfConfigModule = {
  flowId: 'editing_config',
  Component: EditingConfig,
}
